export function deviceHasTouch() {
    // Ancient browser that does not support matchMedia. Assume that they also do not support touch.
    if (!window.matchMedia) {
        return false;
    }
    // Touch device if primary input does not support hover.
    if (window.matchMedia('(hover: none),(-moz-hover: none),(-ms-hover: none),(-webkit-hover: none)').matches) {
        return true;
    }
    // Mozilla's -moz-touch-enabled.
    if (window.matchMedia('(touch-enabled),(-moz-touch-enabled),(-ms-touch-enabled),(-webkit-touch-enabled)').matches) {
        return true;
    }
    // W3C Touch Events.
    if ('ontouchstart' in window) {
        return true;
    }
    // Does not support touch, return false.
    return false;
}
